export const youtubeUrlPattern = /youtube|youtu\.be/;

export function isYoutubeVideoUrl(url: string) {
  return youtubeUrlPattern.exec(url);
}
